<template>
    <b-form-row>
        <b-modal size="xl" button-size="md" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <LeitorList :showSelect="showSelect" @closeMultiplo="closeMultiplo"
                :podeClicarNaAntenaParaSelecionar="podeClicarNaAntenaParaSelecionar" :showCamposCustomizados="true"
                @close="selectItem" :prefix="prefix" />
        </b-modal>

        <lg-form-input-finder v-model="localObject" fieldDescription="nome" :label="label"
            invalidFeedback="Leitor deve ser informado!" description="" @handleClean="selectItem">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import LeitorList from "@/modules/cadastros/leitor/LeitorList.vue";

export default {
    components: {
        LgFormInputFinder,
        LeitorList,
    },

    props: {
        showSelect: {
            type: Boolean,
            default: false
        },

        podeClicarNaAntenaParaSelecionar: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: "page-leitor",
        },
        value: Object,
        label: {
            type: String,
            default: 'Leitor:'
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Leitor",
        },

    },


    data() {
        return {
            localObject: this.value,
            fields: [
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        };
    },

    methods: {
        async closeMultiplo(itens) {
            this.localObject = {nome: 'Vários'};
            this.$emit("closeMultiplo", itens);
            await this.$bvModal.hide(this.id);

        },
        async show() {
            await this.$refs.finder.show();
            this.$bvModal.show(this.id);
        },

        async selectItem(item) {
            this.localObject = item;
            this.$emit("close", item);
            await this.$bvModal.hide(this.id);
        },
    },
};
</script>
